import { Pipe, PipeTransform } from '@angular/core';
import { AuthService } from '../../core/service/auth.service';

/*
 * translate the value
 * Takes an exponent argument that defaults to 1.
 * Usage:
 *   value | modelTranslate:exponent
 * Example:
 *   {{ 2 | exponentialStrength:10 }}
 *   formats to: 1024
*/
@Pipe({
    name: 'currentUserInRole',
    standalone: false
})
export class currentUserInRolePipe implements PipeTransform {

  constructor(private authSvc: AuthService) {

  }

  transform(roles: string[]): boolean {
    return roles && roles?.length ? this.authSvc.hasOneOfRoles(roles) : true;
  }
}
